import { createAction, props } from '@ngrx/store';
import { BookCouponGroupTemplate } from '../models/search-checkbooks.model';

export const GetBookCouponGroupsTemplates = createAction(
  '[Checkbooks: Generate Checkbook]: Get Book Coupon Groups Templates',
);

export const GetBookCouponGroupsTemplatesSuccess = createAction(
  '[Checkbooks: Generate Checkbook]: Get Book Coupon Groups Templates Success',
  props<{ response: BookCouponGroupTemplate[] }>(),
);

export const GetBookCouponGroupsTemplatesFailed = createAction(
  '[Checkbooks: Generate Checkbook]: Get Book Coupon Groups Templates Failed',
  props<{ error: any }>(),
);

export const SelectedBookCouponGroupTempIdChanged = createAction(
  '[Checkbooks: Generate Checkbook]: Selected Book Coupon Group Template Id Changed',
  props<{ bookCouponGroupTempId: number | null }>(),
);

export const CheckbookNumberChanged = createAction(
  '[Checkbooks: Generate Checkbook]: Checkbook Number Changed',
  props<{ checkbookNumber: string }>(),
);

export const SubmitGenerateCheckbookData = createAction(
  '[Checkbooks: Generate Checkbook]: Submit Generate Checkbook Data',
);

export const ValidFromDateChanged = createAction(
  '[Checkbooks: Generate Checkbook]: Valid From Date Changed',
  props<{ validFromDate: Date; validFromDateFormat: string }>(),
);

export const ValidFromDateCleared = createAction(
  '[Checkbooks: Generate Checkbook]: Valid From Date Cleared',
);

export const ValidUntilDateChanged = createAction(
  '[Checkbooks: Generate Checkbook]: Valid Until Date Changed',
  props<{ validUntilDate: Date; validUntilDateFormat: string }>(),
);

export const ValidUntilDateCleared = createAction(
  '[Checkbooks: Generate Checkbook]: Valid Until Date Cleared',
);

export const GenerateCheckbooks = createAction(
  '[Checkbooks: Generate Checkbook] Generate Checkbooks',
);

export const GenerateCheckbooksSuccess = createAction(
  '[Checkbooks: Generate Checkbook] Generate Checkbooks Success',
  props<{ response: any }>(),
);

export const GenerateCheckbooksFailure = createAction(
  '[Checkbooks: Generate Checkbook] Generate Checkbooks Failure',
  props<{ error: any }>(),
);

export const ClearGenerateCheckbookFilters = createAction(
  '[Checkbooks: Generate Checkbook]: Clear Generate Checkbook Filters',
);
